import FormField from 'app/generic/form/views/FormField';


class View extends FormField {

	_onChange(event) {
		super._onChange(event);

		this.trigger('selected', {
			selectedValue: (event.target || {}).value || '',
			instance: this
		});
	}

}

export default View;
